import { Box, Breadcrumb, BreadcrumbItem, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { FC } from 'react';
import styles from './BreadCrumb.module.css';
import { BreadCrumbProps } from './BreadCrumb.props';

const BreadCrumb: FC<BreadCrumbProps> = ({ items }) => (
  <Box mb={6} mt={1} borderBottomColor="black-100" borderBottomWidth={1}>
    <Breadcrumb py="1">
      {items?.map((item, index) => (
        <BreadcrumbItem key={item.link}>
          <Link href={item.link}>
            <Text color={`${index === items.length - 1 ? 'gray' : 'black'}`} fontSize="lg">
              {item.title}
            </Text>
          </Link>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  </Box>
);

export { BreadCrumb };
